import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tiles, Theme, MessageCard, Text, Container, Content, Title, i18n, tokens } from '@simplybenefits/sb-ui-library';
import ChangePassword from '../../containers/Account/ChangePassword.js';
import { setCurrentSidebarItem } from '../../actions/user.js';
import MarketplaceProductOutOutModal from '../../containers/Marketplace/ProductOptOutModal.js';
import CreatePassword from "../Account/CreatePassword.js";
import { getDashboardTiles } from './utils/getDashboardTiles.js';

class Dashboard extends PureComponent {
    state = {
        welcomeMessage: 'Good Morning',
        changePasswordDialogOpen: false,
        createPasswordDialogOpen: false,
        marketplaceProductsToReview: null
    };

    componentDidMount() {
        // check to see if the member has any new available marketplace products
        this._checkForUnseenMarketplaceProducts();

        this._checkForPasswordIsSet();

        const today = new Date();
        const curHr = today.getHours();

        if (curHr < 12) {
            this.setState({
                welcomeMessage: i18n.t(tokens.labels.dashboard.goodMorning)
            });
        } else if (curHr < 18) {
            this.setState({
                welcomeMessage: i18n.t(tokens.labels.dashboard.goodAfternoon)
            });
        } else {
            this.setState({
                welcomeMessage: i18n.t(tokens.labels.dashboard.goodEvening)
            });
        }

        this.props.dispatch(setCurrentSidebarItem('dashboard'));
    }

    _checkForUnseenMarketplaceProducts() {
        const marketplaceProductsToReview = [];
        const purchasedProducts = this.props.marketplace.purchasedProducts;
        const availableProducts = this.props.marketplace.availableProducts;
        const refusedProducts = this.props.marketplace.refusedProducts;
        const acceptedProducts = this.props.marketplace.acceptedProducts;

        if (availableProducts && Object.keys(availableProducts).length > 0) {
            for (const productID of Object.keys(availableProducts)) {
                if (!purchasedProducts[productID] && !refusedProducts[productID] && !acceptedProducts[productID]) {
                    marketplaceProductsToReview.push(productID);
                }
            }
        }

        this.setState({
            marketplaceProductsToReview: marketplaceProductsToReview.length === 0 ? null : marketplaceProductsToReview
        });
    }

    _checkForPasswordIsSet() {
        this.setState({
            createPasswordDialogOpen: this.props.meta.isPasswordSet === false
        });
    }

    _toggleDialog = (type) => {
        this.setState({
            [`${ type }DialogOpen`]: !this.state[`${ type }DialogOpen`]
        });
    };

    render() {
        const { meta, noClaims, whitelabel, coverage } = this.props;
        const claimsBlocked = meta.accountClaimsBlocked || meta.divisionClaimsBlocked || meta.memberClaimsBlocked;
        const showRequiresBeneficiariesMessage = meta.requiresBeneficiaries === true && meta.hasBeneficiaries !== true;
        const isDependent = this.props.meta.isDependent;
        const tiles = getDashboardTiles({ meta, noClaims, coverage });

        return (
            <Container>
                <Content>
                    <Title title={ i18n.t(tokens.titles.dashboard) } />

                    <span>
                        <Text light extraLarge display="inline">{ this.state.welcomeMessage }, </Text>
                        <Text bold extraLarge display="inline" color={ whitelabel.primaryColor || Theme.colors.skyBlue }>{ meta.firstname }</Text>
                        <Text light extraLarge display="inline">.</Text>
                    </span>

                    {
                        meta.isMarketplaceOnly ?
                            <Text light medium margin="5px 0 40px 0">
                                Welcome to your personalized health Marketplace! Here you can view and purchase standalone health benefit products. Use the button below to get started with the Marketplace!
                            </Text>
                            :
                            <Text light medium margin="5px 0 40px 0">
                                { i18n.t(tokens.labels.dashboard.personalizedHealthDashboard) }
                            </Text>
                    }

                    {
                        meta.claimsDisabledForRollover &&
                            <MessageCard
                                title="Claims Temporarily Disabled"
                                subtitle={ `Hi ${ meta.firstname }, claim submission is currently disabled to allow for your yearly claim usage reset. Claim submission will become active again at 12:00 PM PST.` }
                                isError={ true }
                                small
                            />
                    }
                    {
                        claimsBlocked
                            ? (
                                <MessageCard
                                    title={i18n.t(tokens.titles.claimsBlocked)}
                                    subtitle={ i18n.t(tokens.labels.employees.claimsBlockedForMember) }
                                    isError={ true }
                                    small
                                />
                            )
                            : null
                    }

                    {
                        meta.countUserChangeRequestsForReview > 0 &&
                            <MessageCard
                                title={i18n.t(tokens.labels.changeRequests.changeRequestReview)}
                                subtitle={ i18n.t(tokens.labels.changeRequests.administratorHasSubmittedChangeRequestForReview) }
                                small
                                btn
                                btnName={ i18n.t(tokens.labels.changeRequests.reviewChangeRequest) }
                                btnOnClick={() => {
                                    this.props.history.push('/my-account/requestedChanges');
                                }}
                            />
                    }

                    {
                        Number(meta.paymentsSetup) === 0 && Number(meta.requiresCheque) === 0 && (
                            isDependent ?
                                <MessageCard
                                    title={ i18n.t(tokens.titles.noBankingData) }
                                    subtitle={ i18n.t(tokens.labels.dashboard.mainAccountHolderNoPaymentSetup) }
                                    small
                                />
                                :
                                <MessageCard
                                    title={ i18n.t(tokens.titles.noBankingData) }
                                    subtitle={ i18n.t(tokens.labels.dashboard.youNoPaymentSetup) }
                                    btnName={ i18n.t(tokens.buttons.addBankingDetails) }
                                    btn
                                    btnOnClick={() => {
                                        this.props.history.push('/my-account');
                                    }}
                                    small
                                />
                        )
                    }

                    {
                        showRequiresBeneficiariesMessage
                            ? <MessageCard
                                title={ i18n.t(tokens.labels.employees.beneficiaryRequired) }
                                subtitle={ i18n.t(tokens.labels.employees.addBeneficiaryForMember) }
                                btnName={ i18n.t(tokens.buttons.addBeneficiary) }
                                btn
                                btnOnClick={() => {
                                    this.props.history.push('/my-account');
                                }}
                                small
                            />
                            : null
                    }

                    <Tiles tiles={tiles}/>
                </Content>

                {
                    this.state.marketplaceProductsToReview &&
                        <MarketplaceProductOutOutModal
                            productsToReview={this.state.marketplaceProductsToReview}
                            close={() => {
                                this.setState({ marketplaceProductsToReview: null });
                            }}
                        />
                }

                {
                    this.state.changePasswordDialogOpen &&
                        <ChangePassword isForgotPassword close={() => this._toggleDialog('changePassword')}/>
                }

                {
                    this.state.createPasswordDialogOpen &&
                        <CreatePassword close={() => this._toggleDialog('createPassword')}/>
                }

                <span id="dashboard" />
            </Container>
        );
    }
}


Dashboard.propTypes = {
    meta: PropTypes.object,
    whitelabel: PropTypes.object,
    coverage: PropTypes.object
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    meta: state.user.meta,
    whitelabel: state.whitelabel,
    coverage: state.coverage.data,
    noClaims: state.user.noClaims,
    marketplace: state.marketplace
});

export default (connect(mapStateToProps)(Dashboard));